export const REQUEST_HH_QUERY_KEYS = {
  getRegions: "get:/v1/meta/regions",
  getFilters: "get:/v1/meta/filters",
};
